import {
  DialogContent,
  DialogActions,
  Button,
  Dialog,
  DialogProps,
  Box,
  colors,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState, useTransition } from "react";
import LegendComponent from "./LegendComponent";
import {
  AirplaneTicket,
  Apartment,
  InfoOutlined,
  LegendToggle,
  LockClock,
} from "@mui/icons-material";
import { tokens } from "../../../../core/AppStyles";
import { useTranslation } from "react-i18next";

const ActivityLegend = () => {
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
  const { t } = useTranslation();
  const theme = useTheme();
  const customColors = tokens(theme.palette.mode);

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  });

  return (
    <div>
      <InfoOutlined
        onClick={handleClickOpen("paper")}
        sx={{ cursor: "pointer", marginLeft: "10px" }}
      />
      <Dialog
        PaperProps={{ style: { background: customColors.component } }}
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        style={{ width: "auto" }}
      >
        <DialogContent
          dividers={scroll === "paper"}
          sx={{
            width: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "60vh",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <p
              style={{
                width: "100%",
                textAlign: "justify",
                height: "auto",
                padding: "2%",
              }}
            >
              {t("ACTIVITY_LEGEND.LEGEND_TITLE")}
            </p>
            <LegendComponent
              icon={<LockClock />}
              title={t("ACTIVITY_LEGEND.EXPECTED_WORKING")}
              description={t("ACTIVITY_LEGEND.EXPECTED_WORKING_DESCRIPTION")}
              backgroundColor={colors.blue[50]}
            />
            <LegendComponent
              title={t("ACTIVITY_LEGEND.LEAVES")}
              description={t("ACTIVITY_LEGEND.LEAVES_DESCRIPTION")}
              icon={<AirplaneTicket />}
              backgroundColor={colors.green[50]}
            />{" "}
            <LegendComponent
              title={t("ACTIVITY_LEGEND.WORKED")}
              description={t("ACTIVITY_LEGEND.WORKED_DESCRIPTION")}
              icon={<Apartment />}
              backgroundColor={colors.purple[50]}
            />{" "}
            <LegendComponent
              title={t("ACTIVITY_LEGEND.OVERTIME")}
              description={t("ACTIVITY_LEGEND.OVERTIME_DESCRIPTION")}
              icon={<LegendToggle />}
              backgroundColor={colors.blue[50]}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button style={{ color: customColors.invert }} onClick={handleClose}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ActivityLegend;
